import '@mdi/font/css/materialdesignicons.css'
import Vue from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify'
import VueI18n from 'vue-i18n'
import { VueMaskDirective } from 'v-mask'
import VueGtag from 'vue-gtag'
import Rollbar from 'rollbar'
Vue.prototype.$rollbar = new Rollbar({
  accessToken: '538a8257ad5b45b98966a1906bc041e3',
  captureUncaught: true,
  captureUnhandledRejections: true,
  payload: {
    environment: 'production'
  }
})
Vue.config.errorHandler = (err, vm, info) => {
  /* eslint-disable */
  Vue.prototype.$rollbar.error(err)
  throw err
}
Vue.use(VueGtag, {
  config: { id: 'G-8PXQLGW3R9' },
  appName: 'Parque das Águas',
  pageTrackerScreenviewEnabled: true
}, router)
Vue.config.productionTip = false
Vue.use(VueI18n)
Vue.directive('mask', VueMaskDirective)
Vue.filter('fmtNumber', function (value: number) {
  const formatter = new Intl.NumberFormat('pt-BR', {
    currency: 'BRL',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  })
  return formatter.format(value)
})

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app')
